import { Icon, TextField, MenuItem, Snackbar } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useToolbarOptions } from "../context/toolbarOptions";
import { createSharedList, usePremium, useSharedLists } from "../api/firebase";
import "./CreateSharedListScreen.css";
import { useAuth } from "../context/auth";
import { useHistory } from "react-router-dom";
import { logEvent } from "../util/logUtil";
import {
    MAX_SHARED_LISTS_FOR_NON_PREMIUM,
    MAX_SHARED_LISTS_FOR_PREMIUM,
} from "../util/premium";

const CreateSharedListScreen = () => {
    const { setToolbarOptions } = useToolbarOptions();

    const [name, setName] = useState("Watchlist 📀");
    const [message, setMessage] = useState("");
    useApplyToolbarOptions(name, setToolbarOptions, setMessage);

    return (
        <div className="createSharedListContainer">
            <TextField
                style={{ width: "100%" }}
                variant="filled"
                value={name}
                onChange={(event) => setName(event.target.value)}
                label="Name"
            />
            <Snackbar
                open={message !== ""}
                message={message}
                onClose={() => setMessage("")}
                autoHideDuration={1500}
            />
        </div>
    );
};

const useApplyToolbarOptions = (name, setToolbarOptions, setMessage) => {
    const authState = useAuth();
    const isPremium = usePremium();
    const history = useHistory();
    const sharedLists = useSharedLists();

    const [creationInProgress, setCreationInProgress] = useState(false);

    useEffect(() => {
        setToolbarOptions({
            title: "Create Shared List",
            items: [
                <MenuItem
                    key="create_shared_list"
                    disabled={
                        !(
                            authState &&
                            !creationInProgress &&
                            isPremium !== null &&
                            sharedLists !== null
                        )
                    }
                    onClick={async () => {
                        logEvent("Create shared list button clicked");

                        if (!authState.isAuthenticated) {
                            history.push("/login");
                        } else {
                            const doCreate = async () => {
                                setCreationInProgress(true);
                                try {
                                    await createSharedList(
                                        name,
                                        authState.user.uid
                                    );
                                    history.goBack();
                                } catch (e) {
                                    setMessage(
                                        "Failed to create list. Check your internet connection and try again."
                                    );
                                }
                                setCreationInProgress(false);
                            };

                            if (isPremium) {
                                if (
                                    sharedLists.length <
                                    MAX_SHARED_LISTS_FOR_PREMIUM
                                ) {
                                    doCreate();
                                } else {
                                    setMessage(
                                        `You have reached the limit of ${MAX_SHARED_LISTS_FOR_PREMIUM} shared lists.`
                                    );
                                }
                            } else {
                                if (
                                    sharedLists.length <
                                    MAX_SHARED_LISTS_FOR_NON_PREMIUM
                                ) {
                                    doCreate();
                                } else {
                                    setMessage(
                                        `You have reached the limit of ${MAX_SHARED_LISTS_FOR_NON_PREMIUM} shared lists. Upgrade to Movie Pal Premium through our Android app to be able to create up to ${MAX_SHARED_LISTS_FOR_PREMIUM} shared lists.`
                                    );
                                }
                            }
                        }
                    }}
                >
                    <Icon>check</Icon>
                </MenuItem>,
            ],
        });
    }, [
        authState,
        history,
        name,
        setToolbarOptions,
        creationInProgress,
        setCreationInProgress,
        setMessage,
        isPremium,
        sharedLists,
    ]);
};

export default CreateSharedListScreen;
